import { ChildrenProps } from 'styled-system';
import { AnchorHTMLAttributes, ReactNode } from 'react';

export enum ActionItemIntent {
  DANGER = 'danger',
}

export type ActionItemProps = {
  isSelected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  intent?: ActionItemIntent;
  children?: ReactNode;
  leading?: ReactNode;
  trailing?: ReactNode;
} & ChildrenProps;

export type ActionItemStyledProps = {
  isSelected: boolean;
  intent?: ActionItemIntent;
  disabled: boolean;
};

export type ActionLinkItemProps = Partial<ActionItemProps> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

// Todo want to have only Action.Item or Action.Divider as type
export type ActionListProps = ChildrenProps;
